import { Alert } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import React from 'react';
import { messageLibraryEntryActionsAtom } from '../../atoms/messages';

export function LibaryEntryActionMessages() {
  const messageLibraryEntryActions = useAtomValue(
    messageLibraryEntryActionsAtom,
  );
  return messageLibraryEntryActions ? (
    <Alert>{messageLibraryEntryActions.text}</Alert>
  ) : null;
}

export default { LibaryEntryActionMessages };
